var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 168,
    viewBox: "0 0 468 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.551 134.328H330.86C330.211 134.328 329.626 134.733 329.376 135.35L318.562 162.544H343.849L333.035 135.35C332.786 134.727 332.206 134.328 331.551 134.328Z",
    fill: "url(#paint0_linear_4143_29580)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.033 135.357C332.784 134.733 332.204 134.328 331.55 134.328H330.858C330.565 134.328 330.291 134.415 330.054 134.559L335.371 147.922C337.845 154.148 333.258 160.911 326.557 160.911H319.209L318.555 162.55H343.841L333.027 135.357H333.033Z",
    fill: "#D1D3D4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M342.522 159.215H319.891L321.206 155.912H341.207L342.522 159.215Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.851 152.508H322.555L323.87 149.205H338.535L339.851 152.508Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M337.187 145.802H325.227L326.542 142.492H335.872L337.187 145.802Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M334.516 139.097H327.891L329.206 135.787H333.201L334.516 139.097Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.901 162.35H344.508C346.272 162.35 347.699 163.783 347.699 165.541V167.161H314.703V165.541C314.703 163.777 316.137 162.35 317.894 162.35H317.901Z",
    fill: "url(#paint1_linear_4143_29580)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.067 134.215H137.375C136.727 134.215 136.141 134.62 135.892 135.237L125.078 162.43H150.364L139.551 135.237C139.301 134.62 138.722 134.215 138.067 134.215Z",
    fill: "url(#paint2_linear_4143_29580)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.541 135.243C139.292 134.62 138.712 134.215 138.058 134.215H137.366C137.073 134.215 136.799 134.302 136.562 134.445L141.878 147.808C144.353 154.035 139.766 160.797 133.065 160.797H125.717L125.062 162.437H150.349L139.535 135.243H139.541Z",
    fill: "#D1D3D4"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M149.037 159.102H126.406L127.721 155.799H147.722L149.037 159.102Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M146.366 152.395H129.07L130.379 149.092H145.051L146.366 152.395Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.703 145.688H131.742L133.057 142.379H142.388L143.703 145.688Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.032 138.983H134.406L135.721 135.674H139.717L141.032 138.983Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.416 162.236H151.024C152.788 162.236 154.215 163.67 154.215 165.427V167.048H121.219V165.427C121.219 163.664 122.652 162.236 124.41 162.236H124.416Z",
    fill: "url(#paint3_linear_4143_29580)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M307.751 162.818V166.951H292.337V162.818C292.337 160.225 296.102 158.125 296.102 158.125V124.718H170.824V158.125C170.824 158.125 174.539 160.225 174.539 162.818V166.951H159.125V162.818C159.125 160.225 162.952 158.125 162.952 158.125V13.457H170.824V115.593H296.102V13.457H303.98V158.125C303.98 158.125 307.751 160.225 307.751 162.818Z",
    fill: "url(#paint4_linear_4143_29580)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M331.52 32.4167V57.2042C331.52 58.4009 330.28 59.367 328.747 59.367H140.805C139.272 59.367 138.031 58.4009 138.031 57.2042V32.4167C138.031 31.22 139.272 30.2539 140.805 30.2539H328.747C330.28 30.2539 331.52 31.22 331.52 32.4167Z",
    fill: "url(#paint5_linear_4143_29580)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M157.184 32.2988L140.188 50.997V40.7753L147.916 32.2988H157.184Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M180.574 32.2988L157.986 57.317H148.531L171.187 32.2988H180.574Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M204.274 32.2988L181.83 57.317H172.25L194.756 32.2988H204.274Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M228.288 32.2988L205.993 57.317H196.289L218.64 32.2988H228.288Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M252.622 32.2988L230.484 57.317H220.648L242.849 32.2988H252.622Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M277.296 32.2988L255.3 57.317H245.328L267.386 32.2988H277.296Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M302.301 32.2988L280.455 57.317H270.352L292.253 32.2988H302.301Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M325.131 32.2988L302.394 57.317H293.07L315.863 32.2988H325.131Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M329.367 43.082V53.5156L325.933 57.3176H316.484L329.367 43.082Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M331.52 79.3112V104.099C331.52 105.295 330.28 106.262 328.747 106.262H140.805C139.272 106.262 138.031 105.295 138.031 104.099V79.3112C138.031 78.1145 139.272 77.1484 140.805 77.1484H328.747C330.28 77.1484 331.52 78.1145 331.52 79.3112Z",
    fill: "url(#paint6_linear_4143_29580)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.184 79.1934L140.188 97.8916V87.6699L147.916 79.1934H157.184Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M180.574 79.1934L157.986 104.212H148.531L171.187 79.1934H180.574Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.274 79.1934L181.83 104.212H172.25L194.756 79.1934H204.274Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M228.288 79.1934L205.993 104.212H196.289L218.64 79.1934H228.288Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M252.622 79.1934L230.484 104.212H220.648L242.849 79.1934H252.622Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M277.296 79.1934L255.3 104.212H245.328L267.386 79.1934H277.296Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M302.301 79.1934L280.455 104.212H270.352L292.253 79.1934H302.301Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M325.131 79.1934L302.394 104.212H293.07L315.863 79.1934H325.131Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M329.367 89.9766V100.41L325.933 104.212H316.484L329.367 89.9766Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.883 10.1469C155.883 4.54366 160.514 0 166.229 0C171.945 0 176.575 4.54366 176.575 10.1469C176.575 15.7501 171.945 20.2938 166.229 20.2938C160.514 20.2938 155.883 15.7501 155.883 10.1469Z",
    fill: "url(#paint7_linear_4143_29580)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M159.25 10.1478C159.25 6.3708 162.373 3.31055 166.231 3.31055C170.089 3.31055 173.211 6.3708 173.211 10.1478C173.211 13.9249 170.089 16.9851 166.231 16.9851C162.373 16.9851 159.25 13.9249 159.25 10.1478Z",
    fill: "#FFE48E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M289.688 10.1469C289.688 4.54366 294.318 0 300.04 0C305.762 0 310.386 4.54366 310.386 10.1469C310.386 15.7501 305.755 20.2938 300.04 20.2938C294.325 20.2938 289.688 15.7501 289.688 10.1469Z",
    fill: "url(#paint8_linear_4143_29580)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M293.055 10.1478C293.055 6.3708 296.177 3.31055 300.035 3.31055C303.893 3.31055 307.016 6.3708 307.016 10.1478C307.016 13.9249 303.893 16.9851 300.035 16.9851C296.177 16.9851 293.055 13.9249 293.055 10.1478Z",
    fill: "#FFE48E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M466.921 166.283H38.9158C38.6991 166.283 38.5234 166.573 38.5234 166.931V166.969C38.5234 167.327 38.6991 167.617 38.9158 167.617H466.921C467.137 167.617 467.313 167.327 467.313 166.969V166.931C467.313 166.573 467.137 166.283 466.921 166.283Z",
    fill: "#1F1C80"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1295 166.285H0.392367C0.175669 166.285 0 166.575 0 166.933V166.971C0 167.329 0.175669 167.619 0.392367 167.619H29.1295C29.3462 167.619 29.5219 167.329 29.5219 166.971V166.933C29.5219 166.575 29.3462 166.285 29.1295 166.285Z",
    fill: "#1F1C80"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M364.61 106.261L366.106 104.765C366.443 104.429 366.443 103.874 366.106 103.538C365.77 103.201 365.215 103.201 364.878 103.538L363.382 105.033L361.887 103.538C361.55 103.201 360.995 103.201 360.659 103.538C360.322 103.874 360.322 104.429 360.659 104.765L362.155 106.261L360.665 107.751C360.328 108.087 360.328 108.642 360.665 108.979C360.833 109.147 361.058 109.234 361.276 109.234C361.494 109.234 361.718 109.147 361.887 108.979L363.376 107.489L364.866 108.979C365.034 109.147 365.258 109.234 365.477 109.234C365.695 109.234 365.919 109.147 366.087 108.979C366.424 108.642 366.424 108.087 366.087 107.751L364.598 106.261H364.61Z",
    fill: "url(#paint9_linear_4143_29580)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3602 93.5406L96.8561 92.0447C97.1927 91.7082 97.1927 91.1534 96.8561 90.8169C96.5195 90.4803 95.9648 90.4803 95.6282 90.8169L94.1324 92.3127L92.6365 90.8169C92.3 90.4803 91.7452 90.4803 91.4087 90.8169C91.0721 91.1534 91.0721 91.7082 91.4087 92.0447L92.9045 93.5406L91.4149 95.0302C91.0783 95.3668 91.0783 95.9215 91.4149 96.258C91.5832 96.4263 91.8076 96.5136 92.0257 96.5136C92.2439 96.5136 92.4682 96.4263 92.6365 96.258L94.1262 94.7684L95.6158 96.258C95.7841 96.4263 96.0084 96.5136 96.2266 96.5136C96.4447 96.5136 96.6691 96.4263 96.8374 96.258C97.174 95.9215 97.174 95.3668 96.8374 95.0302L95.3478 93.5406H95.3602Z",
    fill: "url(#paint10_linear_4143_29580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4143_29580",
    x1: 318.562,
    y1: 148.439,
    x2: 343.849,
    y2: 148.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4143_29580",
    x1: 314.703,
    y1: 164.755,
    x2: 347.699,
    y2: 164.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4143_29580",
    x1: 125.078,
    y1: 148.326,
    x2: 150.364,
    y2: 148.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4143_29580",
    x1: 121.219,
    y1: 164.648,
    x2: 154.215,
    y2: 164.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4143_29580",
    x1: 233.438,
    y1: 21.2666,
    x2: 233.438,
    y2: 164.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4143_29580",
    x1: 234.776,
    y1: 31.3633,
    x2: 234.776,
    y2: 128.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4143_29580",
    x1: -162.686,
    y1: 31.3628,
    x2: -162.062,
    y2: 128.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4143_29580",
    x1: 155.883,
    y1: 10.1531,
    x2: 176.582,
    y2: 10.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4143_29580",
    x1: 289.688,
    y1: 10.1531,
    x2: 310.386,
    y2: 10.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4143_29580",
    x1: 361.182,
    y1: 103.943,
    x2: 365.907,
    y2: 108.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4143_29580",
    x1: 91.926,
    y1: 91.222,
    x2: 96.6504,
    y2: 96.1895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F5C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.78e5afb3e28f67aa0ca569daabb9d864.svg";
export { ForwardRef as ReactComponent };